import { BusinessRole } from "@1games-ru/region-shared/dist/enums/business/role";
import type { ComponentType } from "react";
import { DeviceEnum } from "@/domains/business/constants/deviceEnum";
import { Tab } from "@/domains/business/constants/tab";
import { InfoState, PcState } from "@/domains/business/slice";
import BusinessEmployeesContainer from "@/domains/business/containers/tablet/tabs/employees/BusinessEmployeesContainer";
import BusinessFeeContainer from "@/domains/business/containers/tablet/tabs/fee/BusinessFeeContainer";
import GoodsAndWarehouseContainer from "@/domains/business/containers/tablet/tabs/goodsAndWarehouse/GoodsAndWarehouseContainer";
import BusinessImprovementsContainer from "@/domains/business/containers/tablet/tabs/improvements/BusinessImprovementsContainer";
import BusinessInfoContainer from "@/domains/business/containers/tablet/tabs/info/BusinessInfoContainer";
import BusinessPricesForServicesContainer from "@/domains/business/containers/tablet/tabs/pricesForServices/BusinessPricesForServicesContainer";
import BusinessPurchaseHistoryContainer from "@/domains/business/containers/tablet/tabs/purchaseHistory/BusinessPurchaseHistoryContainer";
import BusinessSafeContainer from "@/domains/business/containers/tablet/tabs/safe/BusinessSafeContainer";
import BusinessServiceContainer from "@/domains/business/containers/tablet/tabs/service/BusinessServiceContainer";

type BusinessTabProps = {
  onClose: () => void;
  isFirstRender?: boolean;
  info: InfoState | PcState;
  device?: DeviceEnum;
};

type TabsMap = Partial<Record<Tab, ComponentType<BusinessTabProps>>>;

export const getBusinessTabContent = (type: DeviceEnum, role: BusinessRole) => {
  if (!type || !role) return null;

  const build = (tabsMap: TabsMap) => {
    const tabsList = Object.keys(tabsMap) as Tab[];
    return { tabsList, tabsMap };
  };

  // PC ---------------------------------------------------------------------------
  switch (type) {
    case DeviceEnum.PC: {
      switch (role) {
        case BusinessRole.Owner: {
          const tabsMap: TabsMap = {
            [Tab.Info]: BusinessInfoContainer,
            [Tab.GoodsAndWarehouse]: GoodsAndWarehouseContainer,
            [Tab.Employees]: BusinessEmployeesContainer,
            [Tab.Fee]: BusinessFeeContainer,
            [Tab.Improvements]: BusinessImprovementsContainer,
            [Tab.Service]: BusinessServiceContainer,
            [Tab.PricesForServices]: BusinessPricesForServicesContainer,
            [Tab.Safe]: BusinessSafeContainer,
            [Tab.PurchaseHistory]: BusinessPurchaseHistoryContainer,
          };
          return build(tabsMap);
        }
        case BusinessRole.Manager: {
          const tabsMap: TabsMap = {
            [Tab.Info]: BusinessInfoContainer,
            [Tab.GoodsAndWarehouse]: GoodsAndWarehouseContainer,
            [Tab.Employees]: BusinessEmployeesContainer,
            [Tab.Fee]: BusinessFeeContainer,
            [Tab.Improvements]: BusinessImprovementsContainer,
            [Tab.Service]: BusinessServiceContainer,
            [Tab.PricesForServices]: BusinessPricesForServicesContainer,
            [Tab.PurchaseHistory]: BusinessPurchaseHistoryContainer,
          };
          return build(tabsMap);
        }
        case BusinessRole.Worker: {
          const tabsMap: TabsMap = {
            [Tab.Info]: BusinessInfoContainer,
            [Tab.Employees]: BusinessEmployeesContainer,
            [Tab.Service]: BusinessServiceContainer,
          };
          return build(tabsMap);
        }
        default:
          return null;
      }
    }

    // Tablet -----------------------------------------------------------------------
    case DeviceEnum.TABLET: {
      switch (role) {
        case BusinessRole.Owner: {
          const tabsMap: TabsMap = {
            [Tab.Info]: BusinessInfoContainer,
            [Tab.Employees]: BusinessEmployeesContainer,
            [Tab.Fee]: BusinessFeeContainer,
            [Tab.PurchaseHistory]: BusinessPurchaseHistoryContainer,
          };
          return build(tabsMap);
        }
        case BusinessRole.Manager: {
          const tabsMap: TabsMap = {
            [Tab.Info]: BusinessInfoContainer,
            [Tab.Employees]: BusinessEmployeesContainer,
            [Tab.PurchaseHistory]: BusinessPurchaseHistoryContainer,
          };
          return build(tabsMap);
        }
        case BusinessRole.Worker: {
          const tabsMap: TabsMap = {
            [Tab.Info]: BusinessInfoContainer,
            [Tab.Employees]: BusinessEmployeesContainer,
          };
          return build(tabsMap);
        }
        default:
          return null;
      }
    }

    default:
      return null;
  }
};
